import React from "react";
import { useNavigate } from "react-router-dom";
import SEOHead from "../components/SEOHead";

function CareerCommunityInsights() {
  const navigate = useNavigate();

  const handleStart = () => {
    navigate("/get-started");
  };

  return (
    <div style={{ padding: "40px", maxWidth: "1100px", margin: "0 auto" }}>

      <SEOHead
        title="Career Advice From Real Job Seekers"
        description="Learn what actually works in today's job market. Discover real job seeker insights, resume strategies, and career advice to help you land interviews."
        canonical="https://employpilot.com/career-community-insights"
      />


      {/* HERO */}
      <h1 style={{ fontSize: "36px", fontWeight: "bold" }}>
        Get Real Career Advice That Actually Works
      </h1>

      <p style={{ fontSize: "18px", color: "#555", marginTop: "10px" }}>
        Stop guessing your job search. Learn what employers actually look for and
        what real job seekers are doing to land interviews.
      </p>

      <button onClick={handleStart} style={btnPrimary}>
        Get Started
      </button>

      {/* SECTION 1 */}
      <h2 style={{ marginTop: "50px" }}>
        Why Most Job Seekers Struggle
      </h2>

      <p>
        Most job seekers aren’t failing because they lack effort — they’re missing
        insight. They don’t know what employers actually look for, what recruiters
        ignore instantly, or what makes an application stand out.
      </p>

      <p>
        Applying more doesn’t fix the problem. Understanding what works does.
      </p>

      {/* SECTION 2 */}
      <h2 style={{ marginTop: "50px" }}>
        What Employers Actually Look For
      </h2>

      <ul>
        <li>• Clear, results-driven resumes</li>
        <li>• Relevance over quantity</li>
        <li>• Strong positioning and clarity</li>
        <li>• Proof of impact, not just responsibilities</li>
      </ul>

      <p style={{ marginTop: "15px" }}>
        Small changes in how you present yourself can make a major difference.
      </p>

      {/* SECTION 3 */}
      <h2 style={{ marginTop: "50px" }}>
        Where Job Seekers Get Real Answers
      </h2>

      <p>
        Most platforms give generic advice. Real progress comes from understanding
        what actually works in today’s job market.
      </p>

      <p>
        Inside the EmployPilot ecosystem, job seekers are learning, improving, and
        sharing strategies based on real experiences — not guesswork.
      </p>

      {/* SECTION 4 */}
      <h2 style={{ marginTop: "50px" }}>
        What You’ll Learn
      </h2>

      <ul>
        <li>• Why resumes get ignored</li>
        <li>• What actually gets interviews</li>
        <li>• How to position your experience effectively</li>
        <li>• How to improve your job search strategy</li>
      </ul>

      {/* CTA */}
      <div style={{ marginTop: "60px", textAlign: "center" }}>
        <h2>Want the Advantage Most Job Seekers Never Get?</h2>

        <p>
          Stop guessing. Start learning what actually works.
        </p>

        <button onClick={handleStart} style={btnSuccess}>
          Get Started
        </button>
      </div>
     <div
    style={{
      marginTop: "80px",
      textAlign: "center",
      fontSize: "14px",
      color: "#777",
      borderTop: "1px solid #eee",
      paddingTop: "30px"
    }}
  >
    © 2026 EmployPilot. All Rights Reserved.

    <div style={{ marginTop: "10px" }}>
      <a href="/terms" style={{ margin: "0 10px" }}>
        Terms of Use
      </a>

      <a href="/privacy" style={{ margin: "0 10px" }}>
        Privacy Policy
      </a>

      <a href="/contact" style={{ margin: "0 10px" }}>
        Contact
      </a>
    </div>
  </div>
</div>
  );
}

const btnPrimary = {
  backgroundColor: "#007bff",
  color: "#fff",
  padding: "14px 24px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer",
  marginTop: "20px"
};

const btnSuccess = {
  backgroundColor: "#28a745",
  color: "#fff",
  padding: "14px 24px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer",
  marginTop: "20px"
};

export default CareerCommunityInsights;